import { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  FormErrorMessage,
} from "@chakra-ui/react";
import TipTapEditor from "../common/TipTapEditor";

const WidgetStepForm = ({ initialData, onSubmit, onCancel }) => {
  const safeData = initialData || {};
  const [title, setTitle] = useState(safeData.title || "");
  const [content, setContent] = useState(safeData.content || "");
  const [position, setPosition] = useState(safeData.position || "");
  const [errors, setErrors] = useState({});

  // ✅ Re-sync state when editing existing step
  useEffect(() => {
    if (initialData) {
      setTitle(initialData.title || "");
      setContent(initialData.content || "");
      setPosition(initialData.position || "");
    }
  }, [initialData]);

  const validate = () => {
    const newErrors = {};
    if (!title.trim()) newErrors.title = "Title is required";
    if (!content || content.replace(/<[^>]+>/g, "").trim() === "")
      newErrors.content = "Content is required";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    onSubmit({ title, content, position });
  };

  return (
    <Box as="form" onSubmit={handleSubmit} p={4}>
      <VStack spacing={6} align="stretch">
        {/* Title */}
        <FormControl isInvalid={errors.title}>
          <FormLabel>Step Title</FormLabel>
          <Input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter step title"
          />
          <FormErrorMessage>{errors.title}</FormErrorMessage>
        </FormControl>

        {/* Content */}
        <FormControl isInvalid={errors.content}>
          <FormLabel>Step Content</FormLabel>
          <Box border="1px solid" borderColor="gray.200" borderRadius="md" p={2}>
            <TipTapEditor
              key="widget-step-editor"
              content={content}
              onChange={setContent}
            />
          </Box>
          <FormErrorMessage>{errors.content}</FormErrorMessage>
        </FormControl>

        {/* Position */}
        <FormControl>
          <FormLabel>Position</FormLabel>
          <Input
            type="number"
            value={position}
            onChange={(e) => setPosition(e.target.value)}
            placeholder="Step order"
          />
        </FormControl>

        {/* Buttons */}
        <VStack align="flex-start" spacing={3}>
          <Button type="submit" colorScheme="orange">
            Save Step
          </Button>
          {onCancel && (
            <Button variant="outline" onClick={onCancel}>
              Cancel
            </Button>
          )}
        </VStack>
      </VStack>
    </Box>
  );
};

export default WidgetStepForm;